import type { User } from '../../state/types';

type GetEditUserDelegateRequestStatusId = (onBehalfOfUserId: User['id'], delegateUserId: User['id']) => string;

export const getEditUserDelegateRequestStatusId: GetEditUserDelegateRequestStatusId = (
  onBehalfOfUserId,
  delegateUserId
) => `${onBehalfOfUserId}/${delegateUserId}`;
